import { useEffect, useState } from 'react';
import { AppShell } from '../components/AppShell';
import { Avatar } from '../components/Avatar';
import { api } from '../lib/api';
import { useSession } from '../hooks/useSession';

export default function LeaderboardPage() {
  const user = useSession(s => s.user);
  const isGuest = !!user?.isGuest;
  const [rows, setRows] = useState<Awaited<ReturnType<typeof api.leaderboard>> | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (isGuest) return;
    api.leaderboard().then(setRows).catch(e => setErr(e.message));
  }, [isGuest]);

  return (
    <AppShell>
      <h1 className="font-display text-2xl font-bold mb-4">Leaderboard</h1>
      {isGuest ? (
        <div className="panel p-8 text-center space-y-3">
          <div className="text-4xl">🔒</div>
          <h2 className="font-display text-lg font-bold">Leaderboard is for signed-in players</h2>
          <p className="text-ink-200 text-sm max-w-md mx-auto">
            Guest sessions are anonymous and don't count toward the public leaderboard.
            Sign in to claim a spot on the ranks.
          </p>
          <a href="/auth/google" className="btn-primary inline-flex">Continue with Google</a>
        </div>
      ) : err ? (
        <div className="text-rose-400 mb-3">{err}</div>
      ) : !rows ? (
        <div className="text-ink-200 animate-pulse">Loading…</div>
      ) : (
        <div className="panel p-2">
          <table className="w-full text-sm">
            <thead className="text-ink-300 text-xs uppercase">
              <tr><th className="text-left p-2">#</th><th className="text-left p-2">Player</th><th className="p-2">W</th><th className="p-2">L</th><th className="p-2">Played</th><th className="p-2">Win %</th></tr>
            </thead>
            <tbody className="divide-y divide-ink-700/60">
              {rows.map((u, i) => (
                <tr key={u.id} className="hover:bg-ink-700/40">
                  <td className="p-2 w-8">{i + 1}</td>
                  <td className="p-2 flex items-center gap-2">
                    <Avatar src={u.avatar} name={u.name} size={28} />
                    {u.name}
                  </td>
                  <td className="p-2 text-center text-emerald-400">{u.wins}</td>
                  <td className="p-2 text-center text-rose-400">{u.losses}</td>
                  <td className="p-2 text-center">{u.gamesPlayed}</td>
                  <td className="p-2 text-center">{Math.round(u.winRate * 100)}%</td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={6} className="p-4 text-center text-ink-300">No players yet — be the first to win!</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </AppShell>
  );
}
